module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#magazines",
      toString: function () {
        return this.url;
      }
    }